import { render, staticRenderFns } from "./TaskListEquipe.vue?vue&type=template&id=ff6eb728&scoped=true&"
import script from "./TaskListEquipe.vue?vue&type=script&lang=js&"
export * from "./TaskListEquipe.vue?vue&type=script&lang=js&"
import style0 from "./TaskListEquipe.vue?vue&type=style&index=0&id=ff6eb728&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff6eb728",
  null
  
)

export default component.exports